'use-client';
import * as React from 'react';
import type { ISectionProps } from '../../Section/Section.types';
import Section from '../../Section/viewer/Section';

const MembersAreaSection: React.FC<ISectionProps> = props => {
  return <Section {...props} tagName="div" />;
};

export default MembersAreaSection;
